module.exports = __webpack_public_path__ + "img/github-icon.728b3264.png";